import { useEffect, useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { TreeNode } from '@/shared/interfaces';
import Cancel from '@mui/icons-material/Cancel';
import { flattenChildren, gridSizeMdLg10, gridSizeMdLg2 } from '@/shared';
import { CustomAutocomplete, LoaderComponent, TabTextLabel } from '@/shared/components/ui';
import { Control } from 'react-hook-form';
import { useAuthStore } from '@/store/auth';
import { useFetchgetPlanCuentaByEmpresa } from '@/shared/actions/erp';
import Delete from '@mui/icons-material/Delete';
import { CuentasContablesKey, useCuentasContablesStore } from '@/store/erp/shared/gastos.store';

interface PlanCuentaCostoComponenteProps {
  control: Control<any, any>;
}

const PlanCuentaCostoComponente = ({ control }: PlanCuentaCostoComponenteProps) => {

  const [isCreate, setIsCreate] = useState<boolean>(false);
  const [planCuenta, setPlanCuenta] = useState<TreeNode[]>([])
  const addSelectedCuentasContables = useCuentasContablesStore(s => s.setSelectedCuentasContables);
  const [enabled, setEnabled] = useState<boolean>(false);
  const deleteSelectedCuentasContables = useCuentasContablesStore(s => s.deleteSelectedCuentasContables);
  const selectedCuentasContables = useCuentasContablesStore(s => s.cuentasContables);


  //Store
  const empresa = useAuthStore(s => s.user?.empresa)
  //console.log('empresa', empresa)

  //Fetch
  const { isLoading: isLoadingPlanCuenta, data: dataPlanCuenta } = useFetchgetPlanCuentaByEmpresa(empresa!, enabled);
  ///empresa!

  useEffect(() => {
    if (!isLoadingPlanCuenta) {
      const cuentas = flattenChildren(dataPlanCuenta?.cuentas || [])
      setPlanCuenta(cuentas)
    }
  }, [isLoadingPlanCuenta])

  useMemo<TreeNode[]>(() => selectedCuentasContables, [selectedCuentasContables])
  const columns = useMemo<MRT_ColumnDef<TreeNode>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'Numero Cuenta',
        size: 150
      },

      {
        accessorKey: 'name',
        header: 'Nombre de la cuenta',
        size: 500,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: selectedCuentasContables,

    muiTableBodyCellProps: {
      sx: {
        backgroundColor: 'white',
        //border: '1px solid #ccc',
        p: '2px 16px'
      }
    },
    muiTableBodyRowProps: {
      sx: {
        height: '12px'
      }
    },

    muiTableHeadCellProps: {
      sx: {
        borderBlock: '1px solid #ccc'
      }
    },
    positionToolbarAlertBanner: "head-overlay",
    renderTopToolbarCustomActions: () => (
      <Grid container spacing={3}>
        <Grid item xs={12} alignContent={'center'} alignItems={'center'} justifyItems={'center'}>
          {/* <Typography variant='overline' >CATALAGO DE CUENTAS CONTABLES </Typography> */}
          <TabTextLabel text={'CATALAGO DE CUENTAS CONTABLES'} mt={0} pb={0} pl={0} pt={2} />
        </Grid>
        {!isCreate && (
          <Grid item xs={12} justifyContent={'end'} textAlign={'end'}>
            <Tooltip title="Agregar Cuenta Contable" placement='top'>
              <IconButton onClick={() => {
                //table.setCreatingRow(true)
                setEnabled(true)
                setIsCreate(true)
              }} >
                <AddBoxIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )
        }

        {isCreate && (
          <Grid item container xs={12} justifyContent={'space-between'} textAlign={'end'} alignContent={'center'} alignItems={'center'} justifyItems={'center'}>
            <CustomAutocomplete<TreeNode>
              size={gridSizeMdLg10}
              label={'Buscar plan cuenta'}
              name="presentacion"
              options={planCuenta || []}
              valueKey="nombre_compuesto"
              actualValueKey="id"
              defaultValue={''}
              isLoadingData={isLoadingPlanCuenta}
              control={control}
              error={undefined}
              helperText={undefined}
              onChangeRawValue={(e) => {
                const existe = selectedCuentasContables.find(t => t.id == e.id);
                if (existe) return;
                const newData = [...selectedCuentasContables];
                ///console.log("llego",e);
                newData.push({
                  id: e.id,
                  name: e.name,
                });
                addSelectedCuentasContables(newData, CuentasContablesKey.cuentasContables)
              }}
            />
            <Grid item {...gridSizeMdLg2}>
              <IconButton onClick={() => setIsCreate(false)}>
                <Cancel />
              </IconButton>
            </Grid>
          </Grid>
        )}
      </Grid>
    ),

    renderRowActions: ({ row }) => (
      <IconButton onClick={() => {
        deleteSelectedCuentasContables(row.original.id, CuentasContablesKey.cuentasContables);
      }} >
        <Delete />
      </IconButton>
    ),



    renderEmptyRowsFallback: () => (
      <Typography textAlign={'center'}
        sx={{ fontStyle: 'italic', padding: '10px' }}
      >Sin plan de cuenta</Typography>
    ),

    enableRowActions: true,
    positionActionsColumn: 'first',
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
  });

  if (isLoadingPlanCuenta) return <LoaderComponent />

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  );
};

export default PlanCuentaCostoComponente;
